"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassportCampaignFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PassportCampaignFactory = /** @class */ (function (_super) {
    __extends(PassportCampaignFactory, _super);
    function PassportCampaignFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PassportCampaignFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PassportCampaignFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PassportCampaignFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PassportCampaignFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PassportCampaignFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PassportCampaignFactory;
}(contracts_1.ContractFactory));
exports.PassportCampaignFactory = PassportCampaignFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "ClaimableStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
        ],
        name: "CreditScoreContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Recovered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardPaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newRewardsDistributor",
                type: "address",
            },
        ],
        name: "RewardsDistributorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newDuration",
                type: "uint256",
            },
        ],
        name: "RewardsDurationUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "creditScoreThreshold",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "daoAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_account",
                type: "address",
            },
        ],
        name: "earned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "exit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "getReward",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_arcDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsDistributor",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_creditScoreContract",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_daoAllocation",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxStakePerUser",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "_creditScoreThreshold",
                type: "uint16",
            },
        ],
        name: "init",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastTimeRewardApplicable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxStakePerUser",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_reward",
                type: "uint256",
            },
        ],
        name: "notifyRewardAmount",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_tokenAmount",
                type: "uint256",
            },
        ],
        name: "recoverERC20",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDistributor",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_creditScoreAddress",
                type: "address",
            },
        ],
        name: "setCreditScoreContract",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint16",
                name: "_newThreshold",
                type: "uint16",
            },
        ],
        name: "setCreditScoreThreshold",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_maxStakePerUser",
                type: "uint256",
            },
        ],
        name: "setMaxStakePerUser",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_rewardsDistributor",
                type: "address",
            },
        ],
        name: "setRewardsDistributor",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_rewardsDuration",
                type: "uint256",
            },
        ],
        name: "setRewardsDuration",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "setTokensClaimable",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "stake",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakers",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardPerTokenPaid",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardsEarned",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardsReleased",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "userAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "withdraw",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=PassportCampaignFactory.js.map